import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from "react";
import "react-notifications-component/dist/theme.css";
import { Col, Container, Row } from "reactstrap";
import { Capitalize, showAlert } from "../common/functions";
import ResourceDetail from "./resourceDetail";
import ResourceList from "./resourceList";

class ResourcePage extends React.Component {
	state = {
		isView: false,
		page: "",
		id: 0,
		title: "",
	};

	constructor(props: any) {
		super(props);
		var tokenstr = new URLSearchParams(window.location.search).get("page");
		let tValue = tokenstr === null ? "" : tokenstr;
		var idstr = new URLSearchParams(window.location.search).get("id");
		var id = idstr === null ? 0 : parseInt(idstr);
		this.state = {
			isView: false,
			page: tValue,
			id: id,
			title: "Create New",
		};
		this.handleCallbackMethod = this.handleCallbackMethod.bind(this);
	}

	componentDidMount() {
		var tokenstr = new URLSearchParams(window.location.search).get("page");
		let tValue = tokenstr === null ? "" : tokenstr;
		var idstr = new URLSearchParams(window.location.search).get("id");
		var id = idstr === null ? 0 : parseInt(idstr);
		var pageValue = id === 0 ? tValue : "detail";
		this.setState({
			page: pageValue,
			id: id,
			title: "",
			isView: pageValue === "" ? true : false,
		});

		var alertMessage = window.localStorage.getItem("alertMessage");
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem("alertMessage", "");
		}

		document.title = "Featured Resources - Daily Audio Bible Administration";
	}

	handleCallbackMethod(value) {
		this.setState({ title: value });
	}

	render() {
		const { title } = this.state;
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							{this.state.page === "add" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faBoxOpen} />
										<span data-testid="resourcePageTitle">
											{" "}
											Featured Resources -{" "}
											{title != "" ? Capitalize(title) : "Create New"}
										</span>
									</h2>
									<hr />
									<ResourceDetail
										callback={this.handleCallbackMethod}
										id={this.state.id}
									/>
								</div>
							)}
							{this.state.page === "detail" && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faBoxOpen} />
										<span data-testid="resourcePageTitle">
											{" "}
											Featured Resources - {title != "" ? Capitalize(title) : "Edit"}
										</span>
									</h2>
									<hr />
									<ResourceDetail
										callback={this.handleCallbackMethod}
										id={this.state.id}
									/>
								</div>
							)}
							{this.state.page === "" && this.state.isView && (
								<div>
									<h2>
										<FontAwesomeIcon icon={faBoxOpen} />
										<span data-testid="resourcePageTitle"> Featured Resources</span>
									</h2>
									<hr />
									<ResourceList />
								</div>
							)}
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default ResourcePage;
